import { Component } from "react";
import { Helmet } from "react-helmet";
import OtpInput from "react-otp-input";
import { Link } from "react-router-dom";
import "./otp.scss";

export class SignupOtpPage extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct.bind(this)("SignupOtpPage");
    const timercount = 60;
    const storedTime = localStorage.getItem("countdown");
    const initialTime = storedTime ? parseInt(storedTime, 10) : timercount;
    this.state = {
      otp: "",
      verifyDisabled: true,
      loader: false,
      //
      time: initialTime,
      isRunning: true,
      isResendDisabled: false,
    };
    this.countdownInterval = null;
  }

  componentDidMount() {
    this.startCountdown();
  }

  componentWillUnmount() {
    this.clearCountdown();
    localStorage.removeItem("countdown");
  }

  startCountdown = () => {
    if (this.state.isRunning) {
      this.setState({ isResendDisabled: true });
      this.countdownInterval = setInterval(() => {
        this.setState((prevState) => {
          if (prevState.time > 0) {
            localStorage.setItem("countdown", (prevState.time - 1).toString());
            return { time: prevState.time - 1 };
          } else {
            this.clearCountdown();
            localStorage.removeItem("countdown");

            // Update the UI manually if needed
            let timerBox = document.getElementById("otpTimeout");
            if (timerBox) {
              timerBox.innerHTML = `<span class="text-danger">OTP expired</span>`;
            }
            this.setState({ isResendDisabled: false });
            return { isRunning: false };
          }
        });
      }, 1000);
    }
  };

  clearCountdown = () => {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  };

  // ----------------------------------------------------------------

  handleChange(otp) {
    // console.log("otp changed: ", otp.length);
    this.setState({ otp });
    if (otp.length === 4) {
      this.setState({
        otp,
        verifyDisabled: false,
      });
    } else {
      this.setState({
        otp,
        verifyDisabled: true,
      });
    }
  }

  handleOTPverify(e) {
    // console.log("handleOTPverify", this.state.otp);
    let storedSignupData = window.store.getState().root.signupData || {};
    let otpPayload = {
      phone_number: storedSignupData?.phone_number,
      otp: this.state.otp,
    };

    let signupPayload = {
      ...storedSignupData,
    };
    console.log({ otpPayload, signupPayload });

    this.setState({ loader: true });

    this.props.api
      .apiOTPLoginVerify(otpPayload)
      .then((res) => {
        console.log({ handleOTPverify: res });
        if (res) {
          this.props.api
            .apiUserSignup(signupPayload)
            .then((res) => {
              console.log("signup res", res);
              this.setState({ loader: false });
              this.props.navigate("/open/login");
            })
            .catch(() => {
              this.setState({ loader: false });
            });
        }
      })
      .catch(() => {
        this.setState({ loader: false });
      });
  }
  handleRestart = () => {
    const timercount = 60;

    this.clearCountdown();
    localStorage.setItem("countdown", timercount.toString());

    this.setState(
      {
        time: timercount,
        isRunning: true,
        isResendDisabled: true, // Disable resend button again
      },
      () => {
        this.startCountdown(); // Restart the countdown
      }
    );
  };

  handleResendOtp(e) {
    e.preventDefault();
    e.stopPropagation();
    let storedSignupData = window.store.getState().root.signupData || {};
    console.log({ storedSignupData });
    let payload = { ...storedSignupData };
    this.props.api
      .apiGenerateOTP(payload)
      .then((res) => {
        this.props.setstore("signupData", payload);
        this.handleRestart();
        success("OTP resend successfully!");
      })
      .catch(() => {});
  }
  render() {
    let { otp, verifyDisabled, loader, time, isResendDisabled } = this.state;
    return (
      <>
        {loader && (
          <div className="loader-container">
            <div className="spinner"></div>
          </div>
        )}
        <Helmet>
          <title>Sign up OTP - CognoSpace</title>
          <meta name="description" content="Signup OTP page" />
        </Helmet>
        <div className="account-content">
          <div className="container">
            <div className="account-box">
              <div className="account-wrapper">
                <div className="py-3 d-flex justify-content-center">
                  <Link to={"/open/login"}>
                    <img
                      src={imagepaths.CognoSpaceLogoDark}
                      alt="Logo"
                      width="155px"
                    />
                  </Link>
                </div>
                <h3 className="account-title">Verify OTP</h3>
                <p className="account-subtitle">
                  We have sent an OTP to your number
                </p>
                <div>
                  <OtpInput
                    value={otp}
                    onChange={(...args) => this.handleChange(...args)}
                    numInputs={4}
                    separator={<span>-</span>}
                    renderInput={(props) => <input {...props} />}
                    containerStyle="otp_container"
                  />
                  <p className="otp_timer" id="otpTimeout">
                    {time < 10 ? `00:0${time} Sec` : `00:${time} Sec`}
                  </p>

                  <div className="form-group text-center mb-3">
                    <button
                      className="btn btn-primary account-btn w-50 mx-auto"
                      type="button"
                      onClick={(e) => this.handleOTPverify(e)}
                      disabled={verifyDisabled}
                    >
                      Verify
                    </button>
                  </div>
                  <div className="account-footer">
                    <p className="text-black text-center">
                      Not received OTP?
                      <a
                        href="#"
                        className={Object.className({
                          "ms-1": true,
                          "pe-none": isResendDisabled,
                        })}
                        disabled={isResendDisabled}
                        onClick={(...args) => this.handleResendOtp(...args)}
                      >
                        Resend OTP
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect(SignupOtpPage);
